<template>
  <div>
    <div class="home">
      <div v-if="eventInfo.eventBanner">
        <PhotoCard>
          <img
            slot="img"
            :src="eventInfo.eventBanner_url"
            alt=""
            style="width: 100%; max-height: 420px; border-radius: 10px"
          />
          <div
            v-if="eventInfo.eventDesc"
            slot="content"
            class="event-desc"
          >
            <div v-html="eventInfo.eventDesc"></div>
          </div>
        </PhotoCard>
      </div>
      <a-card style="margin-top: 30px" id="apply">
        <div style="font-size: 18px; margin-bottom: 10px">
          <a-icon type="calendar" theme="twoTone" />
          <span class="gap"> 活动时间：{{ eventInfo.eventBegin }}</span>
          <a-divider type="vertical"></a-divider>
          <a-icon type="compass" theme="twoTone" />
          <span class="gap"> 活动地点：{{ eventInfo.eventAddress }}</span>
          <a-divider type="vertical"></a-divider>
          <!-- <a-icon type="fire" theme="twoTone" /> -->
          <!-- <span class="gap"> 参与人数：{{ eventInfo.applyCount }}</span> -->

          <a-button
            style="display: inline-block; margin: 0px 20px; "
            type="danger"
            size="large"
            icon="right-circle"
            :disabled="!eventGoing"
            @click="showApplyEvent"
            >立即报名</a-button
          >
        </div>
        <h1 style="font-weight: 700; font-size: 24px; color: #303133">
          {{ eventInfo.eventName }}
        </h1>
        <div style="overflow: auto" v-html="eventInfo.eventContent"></div>
      </a-card>

      <h1 class="sec-title" v-if="showConfig.targetUser && showConfig.targetUser.length>0">征集对象</h1>
      <p style="text-align: center; font-size: 16px; color: #fff" v-if="showConfig.targetUser && showConfig.targetUser.length>0">
        激发青少年科学兴趣、培养科学好奇心，营造青少年创新人才不断涌现的良好氛围
      </p>
      <div class="oriented animate__animated animate__fadeIn" v-if="showConfig.targetUser && showConfig.targetUser.length>0">
        <a-row :gutter="12" type="flex" justify="space-around">
            <a-col v-for="(u,i) in showConfig.targetUser" :key="i" :xs="24" :sm="24" :md="6" :lg="6" :xl="6" >
              <div v-if="u.avatar" class="img-zoom" style="height: 200px;">
                <img :src="getQiniuUrl(u.avatar)" alt="" />
              </div>
              <h3>{{u.username}}</h3>
            </a-col>
        </a-row>
      </div>
      <!-- <a-divider/> -->
      <h1 class="sec-title" v-if="timeline.length>0">活动日程</h1>
      <div class="animate__animated animate__fadeIn" v-if="timeline.length>0">
        <vue-horizontal-timeline
          timelineBackground="transparent"
          :items="timeline"
        />
      </div>
      <h1 class="sec-title" v-if="eventInfo.siteHere">场地图示</h1>
      <div class="animate__animated animate__fadeIn" v-if="eventInfo.siteHere">
        <image-shadow :src="eventInfo.siteHere_url" :shadow-blur="10">
        </image-shadow>
      </div>
      <!-- <h1 class="sec-title">数据统计</h1>
      <div class="animate__animated animate__fadeIn"></div>
      <div style="text-align: center">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-card>
              <a-statistic
                title="参与人数"
                :value="eventInfo.applyCount"
                :precision="0"
                suffix="人"
                :value-style="{
                  color: '#cf1322',
                  fontSize: '40px',
                  fontFamily: 'fantasy',
                }"
                style="margin-right: 50px"
              >
                <template #prefix>
                  <a-icon type="fire" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :span="12">
            <a-card>
              <a-statistic
                title="作品数量"
                :value="eventInfo.workCount"
                :precision="0"
                suffix="个"
                class="demo-class"
                :value-style="{
                  color: '#3f8600',
                  fontSize: '40px',
                  fontFamily: 'fantasy',
                }"
              >
                <template #prefix>
                  <a-icon type="build" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
        </a-row>
      </div> -->
      <!-- <a-divider/> -->
      <h1 class="sec-title" id="store" v-if="showConfig.showStory">故事分享</h1>
      <div class="store" v-if="showConfig.showStory">
        <a-list
          :grid="{
            gutter: _isMobile() ? 12 : 24,
            xl: 4,
            lg: 4,
            md: 2,
            sm: 2,
            xs: 1,
          }"
          :dataSource="storeDataSource"
        >
          <a-list-item
            class="store-item animate__animated animate__fadeIn"
            slot="renderItem"
            slot-scope="item"
            @click="toCmsDetail(item)"
          >
            <div class="img-zoom">
              <img class="cover" :src="item.cmsCover_url" alt="" />
            </div>
            <h3 class="title">{{ item.cmsTitile }}</h3>
          </a-list-item>
        </a-list>
      </div>
    </div>
    <a-modal
      :width="800"
      :visible="videoVisible"
      :maskClosable="false"
      :title="currentVideo.cmsTitile"
      :destroyOnClose="true"
      @cancel="videoVisible = false"
      :footer="null"
    >
      <video
        style="width: 100%"
        controls
        controlsList="nodownload noremote footbar"
        autoplay
        :src="currentVideo.extraFile_url"
      ></video>
    </a-modal>

    <EventApplyModal ref="applyModal"/>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";
import { getInfo } from "@/api/login";
import PhotoCard from "@/components/common/PhotoCard";
import "@/assets/less/animation.css";
import VueHorizontalTimeline from "@/components/common/VueHorizontalTimeline";
import EventApplyModal from "./modal/EventApplyModal";
import { jumpMixins } from "@/utils/jumpMixins";

export default {
  name: "Home",
  mixins: [mixinDevice, jumpMixins],
  components: {
    PhotoCard,
    VueHorizontalTimeline,
    EventApplyModal,
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
      eventInfo: {},
      eventGoing: false, //活动进行中
      // applyVisible: false,
      articleList: [],
      videoVisible: false,
      currentVideo: {},
      cmsDataSource: [],
      cmsType: 1,
      videoDataSource: [],
      tenantConfig: {},
      token: "",
      peopleDataSource: [],
      storeDataSource: [],
      timeline: [],
      showConfig: {}, //显示设置
      swiperOptions: {
        speed: 800,
        effect: "coverflow", //"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        slidesPerView: 3,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -100,
          depth: 700,
          modifier: 0.5,
          slideShadows: false,
        },
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: true,
        },
        //开启循环模式
        loop: true,
      },
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    if (this.tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
    let eventId = this.$route.query.id;
    this.getHomeEvent(eventId);
    
  },
  watch:{
    $route(v){
      this.jumpToHash()
    }
  },
  mounted() {
  },
  methods: {
    showApplyEvent() {
      if (Vue.ls.get(ACCESS_TOKEN)) {
        //this.$refs.applyModal.open(this.eventInfo.id);
        this.$router.push({path: "/event/apply", query: {id:this.eventInfo.id}});
      } else {
        this.toLogin();
      }
    },
    getUserInfo() {
      getInfo().then((res) => {
        console.log(res);
      });
    },
    getHomeEvent(id) {
      getAction("/teaching/teachingEvent/getHomeEvent", { eventId: id }).then((res) => {
        if (res.success) {
          this.eventInfo = res.result;
          this.timeline = this.eventInfo.teachingEventScheList.map((s) => {
            return {
              content: s.scheTime,
              title: s.scheDesc,
            };
          });
          if(this.eventInfo.showConfig){
            let showConfig = JSON.parse(this.eventInfo.showConfig)
            showConfig.targetUser = showConfig.targetUser.filter(i=>i.username && i.username.trim())
            this.showConfig = showConfig
            if(showConfig.showStory){
              this.getStoreList();
            }
          }
          this.jumpToHash()
          this.watchTime()
        } else {
          this.$message.info(res.message);
        }
      });
    },
    //跳转到锚点
    jumpToHash(){
      if(window.location.hash){
        this.$nextTick(()=>{
          let dom = this.$el.querySelector(window.location.hash)
          if(dom){
            dom.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }
        })
        
      }
    },
    watchTime(){
      let that = this
      let startTime = that.eventInfo.eventBegin?new Date(that.eventInfo.eventBegin).getTime():0
      let endTime = that.eventInfo.eventEnd?new Date(that.eventInfo.eventEnd).getTime():0
      setInterval(function(){
      let now = new Date().getTime()
        console.log(that.eventInfo.eventEnd);
        if(that.eventStatus < 1){
          that.eventGoing = false
          return
        }else{
          that.eventGoing = true
        }
        if((startTime>0 && startTime > now) || (endTime>0 && endTime < now)){
          that.eventGoing = false
        }else{
          that.eventGoing = true
        }
      }, 1000)
    },
    toCmsDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, "_blank");
    },
    getStoreList() {
      this.storeDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsType: 4,
        pageSize: 4,
        cmsStatus: 1,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.storeDataSource = res.result.records;
        }
      });
    },
    getQiniuUrl(text){
      if(!text){
        return;
      }
      if(text.indexOf(",")>0){
        text = text.substring(0,text.indexOf(","))
      }
      if(text.startsWith("http")){
        return text
      }
      return this.tenantConfig.qiniuDomain + "/" + text;
    },
  },
};
</script>

<style lang="less" scoped>
.box-shadow {
  box-shadow: #67aaff99 0px 0px 6px 0px;
}
.oriented {
  text-align: center;
  h3 {
    color: #fff;
  }
}
.event-desc{
   width: 40%;
  margin: auto;
  background-color: #0000008f;
  border-radius: 20px;
  padding: 10px;
  /deep/ *{
    background-color: unset!important;
  }
}

.column-card {
  border-radius: 10px 0 10px 0px;
  margin-bottom: 5px;
  .cms-item {
    cursor: pointer;
    transition: color 0.2s;
  }
  .cms-item:hover {
    color: #1890ff;
  }
  .cms-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .cms-time {
    text-align: right;
    width: 150px;
  }
}

.video-card {
  .cover {
    width: 100%;
    height: 120px;
    // max-height: 140px;
  }
}
.see-more {
  color: #999;
  text-align: right;
  float: right;
}
.see-more:hover {
  color: #1890ff;
}
.sec-title {
  text-align: center;
  margin: 50px 0;
  font-weight: 700;
  font-size: 24px;
  color: #ffffff;
  text-shadow: #000 0px 0px 4px;
}
.container {
  .news {
    height: 50px;
  }
  .common-title {
    h3 {
      font-size: 24px;
      font-weight: normal;
      line-height: 24px;
    }
  }

  .item-card {
    cursor: pointer;
    /deep/.ant-card-body {
      padding: 0;
      margin-top: 0;
      margin-bottom: 25px;
    }
    .cover {
      width: 100%;
      height: 170px;
      margin-bottom: 10px;
    }
  }
  .title {
    color: gray;
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 0;
    overflow: hidden;
  }
  .title:hover {
    color: #1890ff;
  }
}
.store {
  margin-top: 20px;
  .store-item {
    height: 250px;
    overflow: hidden;
    .cover {
      height: 180px;
      width: 100%;
    }
    .title {
      color: #fff;
    }
  }
}

.vue-horizontal-timeline {
  box-shadow: none !important;
  /deep/.timeline {
    overflow-x: auto;
  }
  /deep/.timeline::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }
  /deep/.timeline::-webkit-scrollbar-thumb {
    background-color: rgb(27, 110, 219);
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
    /deep/.timeline::-webkit-scrollbar-thumb:hover {
      cursor: pointer;
    background-color: rgb(11, 93, 201);
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
}

.vue-image-shadow {
  width: 100% !important;
  /deep/img {
    width: 100% !important;
  }
}

.mobile {
  .item-card {
    /deep/.ant-card-body {
      margin-bottom: 12px !important;
    }
    .cover {
      height: 100px !important;
    }
  }
}
</style>